module.exports = __webpack_public_path__ + "img/apple-touch-icon-144x144.89d59ebe.png";